export default __webpack_public_path__ + "static/media/theme-dark-red.9156ffba.svg";